<template>
  <div>
    <v-tabs class="elevation-2" v-model="tabs">
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-master-rekening" key="master-rekening">Master Rekening</v-tab>
      <v-tab href="#tab-rekening" key="rekening">Rekening</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item value="tab-master-rekening" key="master-rekening">
        <ListRekeningMaster></ListRekeningMaster>
      </v-tab-item>
      <v-tab-item value="tab-rekening" key="rekening">
        <ListRekening></ListRekening>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      tabs: ""
    };
  },
  components: {
    ListRekening: () =>
      import(
        /* webpackChunkName: "Rekening" */ "@/views/Master/Rekening/Rekening/List.vue"
      ),
    ListRekeningMaster: () =>
      import(
        /* webpackChunkName: "RekeningMaster" */ "@/views/Master/Rekening/Master/List.vue"
      )
  },
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    })
  },
  mounted() {}
};
</script>

<style lang="scss">
.v-tabs-items {
  background: transparent !important;
  padding-top: 5px;
}
</style>